import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from './locales/en/translation.json';
import enUi from './locales/en/ui.json';
import csTranslation from './locales/cs/translation.json';
import csUi from './locales/cs/ui.json';

const resources = {
  en: {
    translation: enTranslation,
    ui: enUi
  },
  cs: {
    translation: csTranslation,
    ui: csUi
  }
};

i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources,
    fallbackLng: 'en',
    // Only consider the language part (e.g. treat 'cs-CZ' as 'cs') and
    // explicitly declare supported languages so region variants map correctly.
    supportedLngs: ['en', 'cs'],
    load: 'languageOnly',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
    saveMissing: true,
    missingKeyHandler: (lngs, ns, key) => {
      // eslint-disable-next-line no-console
      console.warn(
        `Missing translation key: ${key} in namespace: ${ns} for languages: ${lngs.join(', ')}`
      );
    }
  });

export default i18n;
